import CheckIcon from '@mui/icons-material/Check';

import { isSlideComponentHkcsEnQ1, Question } from '@/types/slide';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../../format';
import { ResultCardUnsupported } from '../cards/ResultCardUnsupported';
import { ResultContainer, ResultTitle } from '../ResultCard';

import { ResultContentHkcsEnQ1 } from './contents/ResultContentHkcsEnQ1.legacy';

export const ResultCardHkcsEnQ1: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();
    const answer = question.answers[0];

    const caption = question.answers.length === 0 ? t('result.message.noResult') : '';

    const timeSpent = formatDuration(question.answers.reduce((total, answer) => total + (new Date(answer.endTime).getTime() - new Date(answer.startTime).getTime()), 0) / 1000);

    if (!isSlideComponentHkcsEnQ1(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    return (
        <ResultContainer>
            <Stack spacing={1} sx={{ width: '640px' }}>
                <ResultTitle variant='h5'>{t('slide.legacy.hkcsEnQ1.title')}</ResultTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    <Typography color={question.answers.length > 0 ? 'text.secondary' : 'text.warning'}>{caption}</Typography>
                    {question.answers.length > 0 && (
                        <Typography color='text.secondary'>
                            {t('result.label.timeSpent')}: {timeSpent}
                        </Typography>
                    )}
                </Box>
            </Stack>
            <ResultContentHkcsEnQ1 question={question} viewOnly={false} />
            <Box
                sx={(theme) => ({
                    backgroundColor: !answer ? 'transparent' : (theme.vars || theme).palette.success.main,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    p: 1,
                    borderRadius: '4px',
                })}
            >
                {!answer ? (
                    <Typography variant='h5' color='warning' textAlign={'center'}>
                        {t('result.label.noResult')}
                    </Typography>
                ) : (
                    <CheckIcon style={{ color: 'white' }} />
                )}
            </Box>
        </ResultContainer>
    );
};
